import { useNavigate, useLocation } from 'react-router-dom';
import { useAtom } from 'jotai';
import { user } from '../state/atoms/user.atom';
import { AppNavItem } from '../types/nav.types';
import { cn } from 'lib/utils';
import { ACCOUNT_NAV_ITEMS, MAIN_NAV_ITEMS } from './nav-items';

const NAV_ITEMS: AppNavItem[] = [...MAIN_NAV_ITEMS, ...ACCOUNT_NAV_ITEMS];

export function MobileNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const [userData] = useAtom(user);

  const visibleItems = NAV_ITEMS.filter((item) => !item.requiresAuth || userData);

  const handleClick = (item: AppNavItem) => {
    if (item.isExternal) {
      window.open(item.path, '_blank');

      return;
    }

    navigate(item.path);
  };

  return (
    <nav className='md:hidden sticky top-0 z-40 border-b border-ob-border-soft bg-ob-shell font-ob'>
      <div className='flex gap-1 overflow-x-auto px-2 py-2 scrollbar-none'>
        {visibleItems.map((item) => {
          const Icon = item.icon;
          const isActive = !item.isExternal && location.pathname === item.path;

          return (
            <button
              key={item.path}
              type='button'
              aria-current={isActive ? 'page' : undefined}
              className={cn(
                'inline-flex shrink-0 items-center gap-1.5 rounded-full px-3 py-2 text-sm font-medium transition-colors',
                isActive
                  ? 'bg-ob-canvas text-ob-text'
                  : 'text-ob-text-muted hover:bg-ob-canvas hover:text-ob-text',
              )}
              onClick={() => handleClick(item)}
            >
              <Icon className='h-4 w-4 text-ob-icon' />
              <span>{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
